import { SelectOption } from "@entities/resources/ui/filter-bar/select";

export const resourceTypes: SelectOption[] = [
  { key: "", value: "Todos" },
  { key: "youtube", value: "YouTube" },
  { key: "instagram", value: "Instagram" },
  { key: "facebook", value: "Facebook" },
  { key: "blog", value: "Blog" },
];
